<template>
  <div
    :class="{'log-activity-user--full': !is_sidebar_minimized}"
    class="log-activity-user"
  >
    <j-log-activity-aside />

    <div class="log-activity-user__content">
      <j-log-activity-login />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import jLogActivityAside from '@/views/user-employee/log-activity/jLogActivityAside';
import jLogActivityLogin from '@/views/user-employee/log-activity/jLogActivityLogin';

export default {
  components: {
    jLogActivityAside,
    jLogActivityLogin,
  },

  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user-employee/log-activity/jLogActivity.vue